export default {"src":"/_next/static/media/dune-analytics.fa2f3d71.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};